import { Link } from "react-router-dom";
import { ArticleBrowser } from "@/pages/SectionPage";
import { KnotDivider } from "@/components/ornaments";
import { useT } from "@/lib/labels";

export default function CodexPage() {
  const t = useT();
  return (
    <div data-testid="codex-page" className="max-w-7xl mx-auto px-6 sm:px-8 py-12">
      <nav className="text-sm font-heading text-[#5e4a35] mb-8"><Link to="/" className="hover:text-[#991b1b]">Home</Link> <span className="mx-2">›</span> All Pages</nav>
      {t("codex.eyebrow") && <p className="eyebrow">{t("codex.eyebrow")}</p>}
      {t("codex.title") && <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-2">{t("codex.title")}</h1>}
      <KnotDivider className="my-10" />
      <ArticleBrowser showSection />
    </div>
  );
}
